export default {
  SET_PARTNER: 'SET_PARTNER',
};
